import {baseApi, extendCrudApiByHousehold} from '@/utils/api.js';

const usersApi = extendCrudApiByHousehold({
  entityNameSingular: 'User',
  entityNamePlural: 'Users',
  entityPath: 'users',
});

// Create operation doesn't exist as users are created by invitation
export const {
  useGetUsersQuery,
  useGetUserQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = usersApi;

const invitationsApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['MyInvitations', 'Invitations'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getInvitations: builder.query({
        query: ({ householdId }) => ({
          url: `/h/${householdId}/invitations/`,
          method: 'GET',
        }),
        providesTags: (result, error, arg) => result ? [
          ...result.data.map(({ id }) => ({ type: 'Invitations', id, householdId: arg.householdId })),
          { type: 'Invitations', id: 'LIST', householdId: arg.householdId }
        ] : [{ type: 'Invitations', id: 'LIST', householdId: arg.householdId }],
      }),
      deleteInvitation: builder.mutation({
        query: ({ householdId, id }) => ({
          url: `/h/${householdId}/invitations/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'Invitations', id: arg.id, householdId: arg.householdId },
          { type: 'Invitations', id: 'LIST', householdId: arg.householdId }
        ],
      }),
      resendInvitation: builder.mutation({
        query: ({ householdId, id }) => ({
          url: `/h/${householdId}/invitations/${id}/.resend`,
          method: 'POST',
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'Invitations', id: arg.id, householdId: arg.householdId },
          { type: 'Invitations', id: 'LIST', householdId: arg.householdId }
        ],
      }),
      createInvitation: builder.mutation({
        query: ({ householdId, data }) => ({
          url: `/h/${householdId}/invitations/`,
          method: 'POST',
          body: data,
        }),
        invalidatesTags: (result, error, arg) => [{ type: 'Invitations', id: 'LIST', householdId: arg.householdId }],
      }),
      getMyInvitations: builder.query({
        query: () => ({
          url: `/invitations/`,
          method: 'GET',
        }),
        providesTags: ['MyInvitations'],
      }),
      acceptInvitation: builder.mutation({
        query: ({ id }) => ({
          url: `/invitations/${id}/.accept`,
          method: 'POST',
        }),
        // No need to invalidate cache for Invitations tag, we don't know the householdId at this team and the user
        // didn't have access to the household before accepting the invitation, therefore he couldn't
        // have fetched the list of invitations.
        //
        // We will invalidate the MyInvitations tag, but it's not necessary as the user will be redirected to the household anyway
        invalidatesTags: (result, error, arg) => [
          { type: 'MyInvitations', id: arg.id, },
          { type: 'MyInvitations', id: 'LIST' }
        ],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useGetInvitationsQuery,
  useDeleteInvitationMutation,
  useResendInvitationMutation,
  useCreateInvitationMutation,
  useGetMyInvitationsQuery,
  useAcceptInvitationMutation,
} = invitationsApi;
